import { motion } from "framer-motion";
import { Check, X } from "lucide-react";

const FALLBACK = [
  { feature: "Has their name in it", generic: false, ours: true },
  { feature: "Built from your memories", generic: false, ours: true },
  { feature: "Lasts forever", generic: false, ours: true },
  { feature: "They'll replay it for years", generic: false, ours: true },
  { feature: "Ready in 12 hours", generic: "Sort of", ours: true },
];

const Cell = ({ v, good }) => {
  if (v === true)
    return <span className={`inline-flex w-7 h-7 rounded-full border-2 border-ink items-center justify-center ${good ? "bg-mint" : "bg-white"}`}><Check size={15} strokeWidth={3} /></span>;
  if (v === false)
    return <span className="inline-flex w-7 h-7 rounded-full border-2 border-ink/20 items-center justify-center bg-cream text-lilac"><X size={14} strokeWidth={3} /></span>;
  return <span className="text-xs font-medium text-lilac">{v}</span>;
};

export default function Comparison({ content }) {
  const brand = content?.brand_name ?? "Vowyo";
  const rows = content?.comparison_rows?.length ? content.comparison_rows : FALLBACK;
  return (
    <section className="py-20 sm:py-28" data-testid="comparison-section">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6 }} className="text-center">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-pink font-semibold mb-4">Be honest</p>
          <h2 className="font-display font-bold text-4xl sm:text-5xl tracking-tight leading-[1.1]">
            They own ten perfumes.<br /><span className="text-pink">Nobody's given them a song.</span>
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7 }}
          className="mt-12 overflow-x-auto rounded-[2rem] bg-white border-[3px] border-ink shadow-[8px_8px_0_#7C3AED]"
          data-testid="comparison-table"
        >
          <table className="w-full min-w-[560px] text-left">
            <thead>
              <tr className="border-b-[3px] border-ink bg-cream">
                <th className="p-5 font-head font-semibold text-sm text-plum">Feature</th>
                <th className="p-5 font-head font-semibold text-sm text-plum text-center">Flowers &amp; cake</th>
                <th className="p-5 text-center bg-sunny/40">
                  <span className="font-display font-bold text-base">{brand}</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={i} className="border-b border-ink/10 last:border-0">
                  <td className="p-5 text-sm font-medium text-ink">{r.feature}</td>
                  <td className="p-5 text-center"><Cell v={r.generic} /></td>
                  <td className="p-5 text-center bg-sunny/40"><Cell v={r.ours} good /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </motion.div>
      </div>
    </section>
  );
}
